import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { DateRange } from '@core/services/data.service';

@Component({
  selector: 'app-date-selector',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.scss']
})
export class DateSelectorComponent implements OnInit {

  @Input()
  public range: boolean = true;

  @Input()
  public value: DateRange = null;

  @Output()
  public selected: EventEmitter<{ name: string, range: DateRange }> = new EventEmitter<{ name: string, range: DateRange }>();

  public cols: Item[][] = [];
  public active: Item = null;

  constructor(private date: DatePipe, private modal: ModalService) { }

  private equals(a: DateRange, b: DateRange) {
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;

    return a.from.getTime() == b.from.getTime() && a.to.getTime() == b.to.getTime();
  }

  ngOnInit(): void {

    let today = new Date().date();

    this.cols = [
      [
        { name: this.date.transform(today, 'dd/MM/yyyy'), range: { from: today, to: today }, single: true },
        { name: this.date.transform(today.addDays(-1), 'dd/MM/yyyy'), range: { from: today.addDays(-1), to: today.addDays(-1) }, single: false },
        { name: 'Theo ngày', range: { from: today.addYears(-2), to: today }, single: true }
      ],

      [0, 1].map<Date>(i => today.beginOfMonth().addMonths(-i)).map<Item>(i => ({
        name: 'Tháng ' + this.date.transform(i, 'MM/yyyy'),
        range: { from: i, to: i.addMonths(1).addDays(-1) },
        single: false
      })).union([{
        name: 'Theo tháng',
        range: { from: today.beginOfYear().addYears(-2), to: today },
        single: false
        }]),
      [0, 1, 2].map<Date>(i => today.beginOfYear().addYears(-i)).map<Item>(i => ({
        name: 'Năm ' + this.date.transform(i, 'yyyy'),
        range: { from: i, to: i.addYears(1).addDays(-1) },
        single: false
      }))
    ];

    if (this.value) {
      this.active = this.cols.many(i => i).first(i => this.equals(i.range, this.value), null);

      if (this.active == null) {
        this.active = this.value.from.getTime() == this.value.to.getTime() ? this.cols[0].last() : this.cols[1].last();
      }
    }
  }

  public activate(item: Item, date: Date = null) {

    if (item == null) {

      this.value = this.active == this.cols[0].last()
        ? {
          from: date,
          to: date
        }
        : {
          from: date,
          to: date.addMonths(1).addDays(-1)
        };

      item = this.cols.many(i => i).first(i => i.range.from.getTime() == this.value.from.getTime() && i.range.to.getTime() == this.value.to.getTime(), this.active.single
        ? {
          name: this.date.transform(date, 'dd/MM/yyyy'),
          single: true,
          range: this.value
        }
        : {
          name: 'Tháng ' + this.date.transform(date, 'MM/yyyy'),
          single: false,
          range: this.value
        });
    }

    if (item != this.cols[0].last() && item != this.cols[1].last()) {

      this.selected.emit({ name: item.name, range: { from: item.range.from, to: item.range.to } });
      this.modal.hide(this);
    }
    else {
      this.active = item;
    }
  }

  public get customizable(): boolean {
    return this.active && (this.active == this.cols[0].last() || this.active == this.cols[1].last());
  }
}

interface Item {
  name: string;
  range: DateRange;
  single: boolean;
}
